<template>
  <ValidationObserver v-slot="{ invalid, handleSubmit }" class="height-100">
    <form @submit.prevent="handleSubmit(onSubmit)" class="height-100">
      <v-layout column justify-space-between fill-height>
        <!-- 폼 영역 시작 -->
        <v-flex>
          <p class="page-title">아이디와 비밀번호를<br />입력해 주세요.</p>

          <!-- 이메일 -->
          <FormValidationInput
            :inputValue.sync="form.email"
            :valid="{ name: 'email', rules: 'required|email|email_duplicate' }"
            title="이메일"
            autocomplete="username"
            placeholder="예) abd@gmail.com"
            tabindex="1"
            autofocus
            clearable
          />

          <!-- 비밀번호 -->
          <FormValidationInput
            :inputValue.sync="form.password"
            :passwordShow.sync="passwordShow"
            :valid="{ name: 'password', rules: 'required|password' }"
            title="비밀번호"
            autocomplete="new-password"
            placeholder="영문, 숫자, 특수문자 조합 8~16자"
            tabindex="2"
            type="password"
          />

          <!-- 비밀번호 확인 -->
          <FormValidationInput
            :inputValue.sync="form.rePassword"
            :passwordShow.sync="rePasswordShow"
            :valid="{ name: 'rePassword', rules: `required|re_password:${form.password}` }"
            title="비밀번호 확인"
            autocomplete="new-password"
            placeholder="비밀번호를 다시 입력해 주세요"
            tabindex="3"
            type="password"
          />
        </v-flex>
        <!-- 폼 영역 끝 -->

        <!-- 하단 영역 시작 -->
        <div class="page-footer-column">
          <v-layout justify-space-between align-center class="notice mb-8">
            <span class="color--gray-80">이미 바이나우 계정이 있으신가요?</span>
            <v-btn
              text
              x-small
              color="primary"
              :to="{ path: '/signin' }"
              id="G3VJQsfeSUyVo55+mYQE6w=="
              class="font-weight-bold px-0 ml-2"
            >
              <b class="color--primary-100">로그인</b>
            </v-btn>
          </v-layout>
          <BasicButton
            block
            large
            type="submit"
            :disabled="invalid"
            tabindex="4"
            height="52"
            id="btn__TN00CjT8zUmGPY3qH6I0Qg"
          >
            다음
          </BasicButton>
        </div>
        <!-- 하단 영역 끝 -->
      </v-layout>
    </form>
  </ValidationObserver>
</template>

<script>
export default {
  components: {
    FormValidationInput: () => import('@/components/common/form/FormValidationInput.vue'),
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
        rePassword: '',
      },
      passwordShow: false,
      rePasswordShow: false,
    }
  },
  methods: {
    onSubmit() {
      this.$emit('next', this.form)
    },
  },
}
</script>
